import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';
import { useLanguage } from '../contexts/LanguageContext';
export function RefundPolicy() {
  const {
    t
  } = useLanguage();
  const sections = t('legal.refund.sections') || [];
  return <LegalLayout title={t('legal.refund.title')} lastUpdated="October 24, 2024" data-id="element-222">
      <p data-id="element-223">{t('legal.refund.intro')}</p>

      {sections.map((section: any, index: number) => <div key={index} data-id="element-224">
          <h2 data-id="element-225">{section.heading}</h2>
          {section.paragraphs.map((p: string, pIndex: number) => <p key={pIndex} data-id="element-226">{p}</p>)}
          {section.list && <ul data-id="element-227">
              {section.list.map((item: string, lIndex: number) => <li key={lIndex} data-id="element-228">{item}</li>)}
            </ul>}
        </div>)}
    </LegalLayout>;
}